import { Component, OnInit, Input } from '@angular/core';
import { JobcardService } from '../../../../../services/jobcard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CollectionsService } from '../../../../../services/collections.service';

@Component({
  selector: 'app-jobcard-attachments-phone',
  templateUrl: './jobcard-attachments-phone.component.html',
  styleUrls: ['./jobcard-attachments-phone.component.scss'],
})
export class JobcardAttachmentsPhoneComponent implements OnInit {
  @Input() jobCardID;
  @Input() partnerID;
  @Input() customerID;
  @Input() qrCodeIdentifier;
  public attachments: any = [];
  public loading: boolean = false;
  //public jobcard: string = '';
  //public fullCard: any;
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private jobcardService: JobcardService,
    public collectionsService: CollectionsService,
  ) {}

  ngOnInit() {
    if (!this.jobCardID && !this.qrCodeIdentifier) {
      this.qrCodeIdentifier =
        this.route.snapshot.queryParams['QRCodeIdentifier'];
      this.jobCardID = this.route.snapshot.paramMap.get('jobCardID');
    }

    this.getJobCard();
    
  }

  getJobCard() {
    // this.collectionsService.getServiceJobCardNoAuth(this.jobCardID).subscribe(
    //   (res) => {
    //     this.jobcard = res.number;
    //     this.fullCard = res;
    //     this.getAttachments();
    //   },
    //   (err) => {},
    // );

    this.getAttachments();
  }

  getAttachments() {
    this.loading = true;
    this.jobcardService
      .getJobCardAttachmentsV1(this.jobCardID, this.customerID, this.partnerID, this.qrCodeIdentifier)
      .subscribe(
        (attachments) => {
          this.attachments = attachments;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        },
      );
  }

  deleteAttachment(attachment) {
    this.loading = true;
    this.jobcardService
      .deleteJobCardAttachment(attachment.id, this.qrCodeIdentifier)
      .subscribe(
        (attachments) => {
          this.attachments = attachments;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        },
      );
  }

  async addAttachment(event) {
    if (event.target.files && event.target.files.length > 0) {
      for (var i = 0; i < event.target.files.length; i++) {
        var file = event.target.files[i];
        var data = await this.readFileAsync(file);

        var attachment = {
          ServiceLogID: 0,
          ServiceID: this.jobCardID,
          MediaType: file.type,
          MediaData: data,
          FileName: file.name,
        };

        this.jobcardService
          .addJobCardAttachment(attachment, this.qrCodeIdentifier)
          .subscribe(
            (attachments) => {
              this.attachments = attachments;
            },
            (error) => {
              this.loading = false;
            },
          );
      }
    }
  }

  readFileAsync(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result.toString());
      };
      reader.onerror = reject;
    });
  }

  openAttachment(item) {
    window.open(item.mediaURL, '_blank');
  }

  updateFileName(event, attachment) {
    console.log(event);
    console.log(attachment);

    var data = {
      ID: attachment.id,
      ServiceID: attachment.serviceID,
      FileName: attachment.fileName,
    };
    this.jobcardService.updateJobCardAttachment(data).subscribe((result) => {
      event.deactivate();
    });
  }
}
